<template lang="pug">
.auth
  .auth_form
    v-sheet(v-if="step == 1")
      .referrer(v-if="isReferrerUrl && isMobile")
        span.referrer__text {{ $t('label.transition.source') }}
        a.referrer__logo(href="https://www.emanat.az/az"  target="_blank")
          img(alt="emanat" src="@/assets/e-manat.svg")
      h2.mb-10(:class="isMobile?'text-center':''") {{ $t('misc.auth.reset.title') }}
      v-form(ref="reset" v-model="resetForm" autocomplete="false" @submit.prevent='forgot')
        v-text-field(
          prefix="+994"
          outlined
          v-maska:[options]="auth.username"
          :label="$t('label.phone_number')"
          :rules="rules.username"
          @input="message = ''"
          required
          :error-messages="message")
        v-btn.rounded-lg(depressed block x-large color="primary"
        type="submit" :disabled="!resetForm" :loading="loading" id="reset_password")
          | {{ $t('action.reset_password') }}
      .mt-10.text-center
        router-link.text-decoration-none(id="mobile_back_to_login" :to="{ name: 'login' }") {{ $t('action.back_to_login') }}
    //- 2
    v-sheet(
      v-if="step == 2")
      h2.mb-10 {{ $t('misc.auth.otp.confirm.title') }}
      p.text-small.text-center(
        v-html="$t('misc.auth.otp.label', { phone: `+994 ${this.auth.username.masked}` })")
      //- TODO define values for v-model="valid"
      v-form(ref="form" v-model="valid" lazy-validation autocomplete="false" @submit.prevent="confirm")
        v-otp-input(length="6" v-model="otp" required :error-messages="message"
        @input="message=''" @finish="confirm")
        small.red--text.text--lighten-1 {{ message }}
        v-btn.mt-6.rounded-lg(id="forgot_otp_confirm"
          @click="confirm" type="submit"
          depressed block x-large color="primary" :loading="loading"
          :disabled="!(otp.length === 6)||time!==0") {{ getTimer||$t('action.confirm') }}
      .mt-10.text-center
        span {{ $t('misc.auth.without_otp_code') }}
        =" "
        v-btn.text-button(id="forgot_otp_send_again" :ripple="false"
        :disabled="loading" color="primary" text plain
        @click.native.prevent="sendAgain") {{ $t('action.send_again') }}
    //- 3
    v-sheet(
      v-if="step == 3")
      h2.mb-10 {{ $t('misc.auth.set_new_password.title') }}
      v-form(ref="form" v-model="resetPasswordConfirmForm" autocomplete="false" @submit.prevent="reset")
        .data-tip
          v-text-field(
            :append-icon="password ? '$show-password' : '$hide-password'"
            outlined
            v-model="auth.password"
            :label="$t('label.new_password')"
            type="password"
            :error="message.length > 0"
            @input="message = ''"
            :type="password ? 'text' : 'password'"
            @click:append="password = !password"
            @keyup="checkPasswordStrength"
            required)
          ul(v-if="ruleLength<5")
            li(v-for="rule in rulesTooltip" :key="rule")
              v-icon(v-if="!rule.status") $check-circle-gray
              v-icon(v-else) $check-tooltip
              span {{ $t(rule.message) }}
        v-text-field(
          :append-icon="passwordConfirm ? '$show-password' : '$hide-password'"
          outlined
          v-model="auth.passwordConfirmation"
          type="password"
          :rules="rules.confirm_password"
          :label="$t('label.confirm_password')"
          v-on:blur="checkPasswordMatch"
          :error-messages="passwordNotMatch"
          required
          :error="message.length > 0"
          :type="passwordConfirm ? 'text' : 'password'"
          @click:append="passwordConfirm = !passwordConfirm"
          @input="message = ''")
        v-btn.rounded-lg(id="reset_password_confirmation" depressed block x-large color="primary" :loading="loading" :disabled="!resetPasswordConfirmForm" type="submit")
          | {{ $t('action.reset_password') }}
      .mt-10.text-center
        router-link.text-decoration-none(id="back_to_login" :to="{ name: 'login' }") {{ $t('action.back_to_login') }}
    v-sheet(
      v-if="step === 4")
      p I should log you in!
  AppFrame(
    :frameTitle="authLoginFrameTitle"
    :frameContents="authLoginFrameContents"
    :hasDynamicQr="true"
  )
</template>
<script>
import { ValidationRequired } from '@/rules/required';
import { ValidationPattern } from '@/rules/pattern';
import { ForgotPasswordRequests } from '@/services/http/forgot-password-requests';
import { authLoginFrameTitle, authLoginFrameContents } from '@/constants/auth';
import timerMixin from '@/mixins/timer';
import { convertBase64 } from '@/helpers/base64Encoder';
import AppFrame from '@/views/auth/components/AppFrame';
// import { UserService } from '@/services/user-service';

export default {
  name: 'ForgotPasswordPage',
  components: {
    AppFrame,
  },
  mixins: [timerMixin],
  data() {
    return {
      message: '',
      loading: false,
      password: false,
      authLoginFrameTitle,
      authLoginFrameContents,
      get isReferrerUrl() {
        return !!sessionStorage.getItem('referrerUrl');
      },
      passwordConfirm: false,
      resetPasswordConfirmForm: true,
      ruleLength: 0,
      resetForm: true,
      passwordNotMatch: '',
      auth: {
        username: {
          masked: '',
          unmasked: '',
          completed: false,
        },
        password: '',
        passwordConfirmation: '',
      },
      options: {
        eager: true,
        mask: '## ### ## ##',
      },
      otpExpireTime: 0,
      token: '',
      otp: '',
      phone: '',
      step: 1,
      timer: false,
      rules: {
        password: [
          ValidationRequired(),
          ValidationPattern('^\\S*$', 'label.register_error.whitespace'),
          ValidationPattern('(.*[A-Z].*)', 'label.auth.uppercase'),
          ValidationPattern('(.*[a-z].*)', 'label.auth.lowercase'),
          ValidationPattern('(.*\\d.*)', 'label.auth.number'),
          ValidationPattern('(.*\\W.*)', 'label.auth.character'),
          ValidationPattern('(.{8,})', 'label.auth.least_symbol'),
          ValidationPattern('(.{1,30})', 'label.auth.most_symbol'),
        ],
        username: [ValidationRequired()],
        confirm_password: [ValidationRequired(), (value) => {
          if (value === this.auth.password) {
            return true;
          }

          return this.$t('label.register_error.match');
        }],
      },
      rulesTooltip: [
        { message: 'label.auth.min_max_symbols', regex: /.{8,30}/, status: false },
        { message: 'label.auth.uppercase', regex: /[A-Z]+/, status: false },
        { message: 'label.auth.lowercase', regex: /[a-z]+/, status: false },
        { message: 'label.auth.number', regex: /[0-9]+/, status: false },
        { message: 'label.auth.character', regex: /\W+/, status: false },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  methods: {
    convertBase64,
    checkPasswordStrength() {
      this.rulesTooltip.forEach((condition) => {
        if (condition.regex.test(this.auth.password)) {
          condition.status = true;
        } else {
          condition.status = false;
        }
      });
      this.ruleLength = this.rulesTooltip.filter((rule) => rule.status === true).length;
    },
    checkPasswordMatch() {
      if (this.auth?.password !== this.auth?.passwordConfirmation) {
        this.passwordNotMatch = this.$t('label.register_error.match');
      } else this.passwordNotMatch = '';
    },
    async forgot() {
      if (!this.$refs.reset.validate()) {
        return;
      }

      this.loading = true;
      const [response, error] = await ForgotPasswordRequests.forgot({
        username: `+994${this.auth.username.unmasked}`,
      });
      this.loading = false;

      if (error) {
        this.message = error.errorDetails[0].message;
      } else {
        console.log(response);
        if (response?.data?.otpRequired) {
          this.step = 2;
          this.otpExpireTime = response?.data?.otpExpireTime;
          this.token = response?.data?.token;
          this.setTimer(this.otpExpireTime);
        }
      }
    },
    async confirm() {
      this.loading = true;
      const [response, error] = await ForgotPasswordRequests.confirm({
        token: this.token,
        otp: this.otp,
      });
      this.loading = false;

      if (error) {
        this.message = error.errorDetails[0].message;
        // console.log(error.errorDetails[0].message);
        this.otp = '';
      } else {
        this.resetTimer();
        this.step = 3;
        this.token = response?.data?.token;
      }
    },
    async reset() {
      this.loading = true;
      const [, error] = await ForgotPasswordRequests.reset({
        token: this.token,
        password: this.auth.password,
      });
      this.loading = false;

      if (error) {
        this.message = error.errorDetails[0].message;
        // console.log(error.errorDetails[0].message);
        this.$notify.error(error.errorDetails[0].message);
      } else {
        this.$notify.success(this.$t('label.success'));
        this.$router.replace({ name: 'login' });
      }
    },
    async sendAgain() {
      this.loading = true;
      const [response, error] = await ForgotPasswordRequests.forgot({
        username: `+994${this.auth.username.unmasked}`,
      });
      this.loading = false;
      if (error) {
        this.resetTimer();
        this.message = error.errorDetails[0].message;
      } else {
        this.otpExpireTime = response?.data?.otpExpireTime;
        this.setTimer(this.otpExpireTime);
        this.token = response?.data?.token;
        this.otp = '';
        this.message = '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/auth.scss';
.v-btn--loading {
  opacity: 0.6
}
.text-button.v-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  padding-bottom: 2px;
  font-size: inherit !important;
  letter-spacing: normal !important;
  text-transform: unset !important;
}
</style>
